export type ProgramEditorTab = "cursos" | "dados" | "vitrine";
export type ProgramsSearch = { trail?: string; tab?: ProgramEditorTab; create?: boolean };

// A página de edição usa a mesma autorização de entrada da área de Trilhas.
export function programsSearch(search: Record<string, unknown>): ProgramsSearch {
  if (search.create === true || search.create === "true") return { create: true };
  const trail =
    typeof search.trail === "string" && search.trail.trim() ? search.trail.trim() : undefined;
  if (!trail) return {};
  const tab = search.tab === "dados" || search.tab === "vitrine" ? search.tab : "cursos";
  return { trail, tab };
}
